export const STORAGE_KEYS = {
  AUTH_TOKEN: '@app/auth/token',
  USER: '@app/user/info',
};
export const EVENT_DEFAULT_RADIUS = 5;
